import { configureStore } from "@reduxjs/toolkit"
import thunk from "redux-thunk"
import errorMiddleware from "./middlewares/errorMiddleware"

// import globalMiddleware from "./middlewares/globalMiddleware"
import rootReducer from "./reducers"

const inititalState = {}
export const store = configureStore({
	reducer        : rootReducer,
	preloadedState : inititalState,
	middleware     : [
		thunk,
		errorMiddleware
	]
})
